import { createStore } from 'vuex'
import userInfo from './module/userInfo'
import permissions from './module/permissions'
export default createStore({
  state: {
    isCollapse: false // 侧边栏展开收起
  },
  getters: {},
  mutations: {
    setIsCollapse (state) {
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {},
  modules: {
    userInfo,
    permissions
  }

})
